module.exports = __webpack_public_path__ + "static/img/20-清华大学附属中学永丰学校东校区1.eb71e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/20-清华大学附属中学永丰学校东校区1.png
// module id = Qa6t
// module chunks = 0